module.exports = __webpack_public_path__ + "img/half_circle_2.ec86d2fb.png";